import React from 'react'

class FooterComponent extends React.Component {
    render() {
        return <div className="footer">
            <h2>Kontaktai</h2>
            <div>Direktorius: +37065501043, info@granwood.lt 
Pardavimai : +37065279471 
komercija@granwood.lt, jsc.granwood@gmail.com</div>
            <div>Korespondencijai/ For correspondence : LT- 68291 Marijampolė Druskininkų g. 8</div>
            <div>Registracija / Registration: UAB Granwood LT- 68174 Kazlu Ruda Daukanto g. 19</div>
            <div>Įm.kodas: 302552776, 
PVM kodas: LT 100005685214</div>




        </div>
    }
}

export default FooterComponent